export default __webpack_public_path__ + "static/media/full-screen-enabled.6054abf7.svg";